import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import BootstrapTable from 'react-bootstrap-table-next'
import filterFactory from 'react-bootstrap-table2-filter'

import componentStyles from 'assets/theme/views/admin/react-bs-table.js'

const useStyles = makeStyles(componentStyles)

function ProductsTable(props) {
    const classes = { ...useStyles() }

    // Footer totals
    let generatedSum = 0
    let rejectedSum = 0
    let unallocatedSum = 0
    let soldSum = 0
    let soldRevenueSum = 0
    let potentialRevenueSum = 0
    for (const row of props.products) {
        generatedSum += parseInt(row.generated) || 0
        rejectedSum += parseInt(row.rejected) || 0
        unallocatedSum += parseInt(row.unallocated) || 0
        soldSum += parseInt(row.sold) || 0
        soldRevenueSum += parseFloat(row.soldRevenue) || 0
        potentialRevenueSum += parseFloat(row.potentialRevenue) || 0
    }

    const colStyle = { whiteSpace: 'normal' }
    const numStyle = { ...colStyle, textAlign: 'right' }

    const columns = [
        {
            dataField: 'product',
            text: 'Product',
            headerStyle: () => colStyle,
            style: colStyle,
            formatter: (cell, row) => <Box className='primary-text'>{row.product}</Box>,
            footer: 'Total'
        },
        {
            dataField: 'generated',
            text: 'Generated',
            headerStyle: () => numStyle,
            style: numStyle,
            formatter: (cell, row) => <>{row.generated}</>,
            footer: String(generatedSum),
            footerStyle: () => numStyle
        },
        {
            dataField: 'rejected',
            text: 'Rejected',
            headerStyle: () => numStyle,
            style: numStyle,
            formatter: (cell, row) => <>{row.rejected}</>,
            footer: String(rejectedSum),
            footerStyle: () => numStyle
        },
        {
            dataField: 'unallocated',
            text: 'Unallocated',
            headerStyle: () => numStyle,
            style: numStyle,
            formatter: (cell, row) => <>{row.unallocated}</>,
            footer: String(unallocatedSum),
            footerStyle: () => numStyle
        },
        {
            dataField: 'sold',
            text: 'Sold',
            headerStyle: () => numStyle,
            style: numStyle,
            formatter: (cell, row) => <>{row.sold}</>,
            footer: String(soldSum),
            footerStyle: () => numStyle
        },
        {
            dataField: 'price',
            text: 'Price',
            headerStyle: () => numStyle,
            style: numStyle,
            formatter: (cell, row) => <>€{row.price.toFixed(2)}</>,
            footer: '',
            footerStyle: () => numStyle
        },
        {
            dataField: 'soldRevenue',
            text: 'Revenue (Sold)',
            headerStyle: () => numStyle,
            style: numStyle,
            sort: true,
            formatter: (cell, row) => <>€{(row.soldRevenue || 0).toFixed(2)}</>,
            footer: '€' + soldRevenueSum.toFixed(2),
            footerStyle: () => numStyle
        },
        {
            dataField: 'potentialRevenue',
            text: 'Potential Revenue',
            headerStyle: () => numStyle,
            style: numStyle,
            sort: true,
            formatter: (cell, row) => <>€{(row.potentialRevenue || 0).toFixed(2)}</>,
            footer: '€' + potentialRevenueSum.toFixed(2),
            footerStyle: () => numStyle
        }
    ]

    return (
        <Card>
            <>
                <CardHeader
                    subheader={
                        <>
                            <Box display='flex' style={{justifyContent: 'space-between'}}>
                                <Box>
                                    <Box
                                        component={Typography}
                                        variant='h2'
                                        marginBottom='0!important'
                                    >
                                        <Box component='span'>Active Products</Box>
                                    </Box>
                                </Box>
                            </Box>
                        </>
                    }
                    classes={{ root: classes.cardHeaderRoot }}
                ></CardHeader>
                
                <div className='table-container'>
                    <BootstrapTable
                        keyField='product'
                        data={ props.products }
                        columns={ columns }
                        filter={ filterFactory() }
                        noDataIndication={<Box>No active products</Box>}
                        wrapperClasses='equal-width-products-table'
                    />
                </div>
            </>
        </Card>
    );
}

export default ProductsTable
